var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.888,
    height: 14.167,
    viewBox: "0 0 18.888 14.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chart-bar",
    "data-name": "Icon awesome-chart-bar",
    d: "M480.3,4048.128H463.18a1.182,1.182,0,0,1-1.181-1.181v-12.4a.591.591,0,0,1,.59-.59h1.181a.591.591,0,0,1,.59.59v11.215H480.3a.591.591,0,0,1,.59.59v1.18A.591.591,0,0,1,480.3,4048.128Zm-1.063-4.722h-1.416a.512.512,0,0,1-.472-.472v-8.5a.512.512,0,0,1,.472-.472h1.416a.512.512,0,0,1,.472.472v8.5A.512.512,0,0,1,479.235,4043.406Zm-3.542,0h-1.416a.512.512,0,0,1-.472-.472v-4.958a.5.5,0,0,1,.472-.471h1.416a.5.5,0,0,1,.472.471v4.958A.512.512,0,0,1,475.694,4043.406Zm-3.542,0h-1.416a.512.512,0,0,1-.472-.472v-7.319a.5.5,0,0,1,.472-.472h1.416a.5.5,0,0,1,.472.472v7.319A.512.512,0,0,1,472.152,4043.406Zm-3.542,0h-1.416a.512.512,0,0,1-.472-.472v-2.6a.512.512,0,0,1,.472-.472h1.416a.5.5,0,0,1,.472.472v2.6A.512.512,0,0,1,468.61,4043.406Z",
    transform: "translate(-462 -4033.962)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.2b352a52b0588dab62f56a7d1c1e436d.svg";
export { ForwardRef as ReactComponent };